import { ListContainer } from "common/components/lists/ListContainer";
import { ListItem } from "common/components/lists/ListItem";
import { Loading } from "common/components/Loading";
import { NoDataError } from "common/components/NoDataError";
import { useSimpleQuery } from "common/graphql/useSimpleQuery";
import { FeedbackListItem } from "domain/feedback/FeedbackListItem";
import {
  getFeedbackTitle,
  isAnswered,
  sortFeedbackList,
} from "domain/feedback/util";
import gql from "graphql-tag";
import * as React from "react";
import { GetFeedbackPageData } from "__generated__/types";

const DATA_QUERY = gql`
  query GetAnsweredQuestionsData {
    feedbackList(filter: { onlySubmittedByMe: true }) {
      id
      givenOn {
        ... on FeedbackGivenOnFolder {
          elementId
          folder {
            id
            title
          }
        }
        ... on FeedbackGivenOnKurssloeyfe {
          elementId
          kurssloeyfe {
            id
            title
          }
        }
      }
      messages {
        submittedAt
        submittedBy {
          id
        }
        body {
          isMarkdown
          content
        }
      }
    }
  }
`;

export const AnsweredQuestions: React.FC = () => {
  const { loadingOrError, data } =
    useSimpleQuery<GetFeedbackPageData>(DATA_QUERY);

  if (loadingOrError) {
    return <Loading />;
  }

  if (!data || !data.feedbackList) {
    return <NoDataError />;
  }

  const sortedFeedbackList = [...data.feedbackList];
  sortedFeedbackList.sort(sortFeedbackList);

  const answeredFeedbacks = sortedFeedbackList.filter(
    (e) => isAnswered(e) && !e.givenOn,
  );
  return (
    <>
      {answeredFeedbacks.length === 0 ? (
        <p>Ingen besvarte spørsmål</p>
      ) : (
        <ListContainer>
          {answeredFeedbacks.map((feedback) => (
            <ListItem key={feedback.id}>
              <FeedbackListItem
                id={feedback.id}
                title={getFeedbackTitle(feedback)}
                canAnswer={true}
                isQuestion={!feedback.givenOn}
                answerButtonTitle="Ny melding"
              />
            </ListItem>
          ))}
        </ListContainer>
      )}
    </>
  );
};
